// extracted by mini-css-extract-plugin
export var content = "newsletter-game-module--content--1908e";
export var spin = "newsletter-game-module--spin--47ab6";
export var wrapper = "newsletter-game-module--wrapper--d1a07";